/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 7/17/15.
 */
'use strict';
angular.module('prism-ui.package').controller('NewPackageModalController',
	function ($uibModalInstance, ContentResourceFactory, ModalService, PackageResourceFactory) {

		var self = this;
		var defaultContent = {name: '<no selection>'};

		self.selectedContent = defaultContent;
		self.contentType = 'Series';
		self.name = '';
		self.numPackages = 1;
		self.packageType = {};

		self.onOk = function () {
			var newPackage = {
				name: self.name,
				content: self.selectedContent,
				categoryType: self.packageType,
				purgeOnIngest: true,
				autoDeliver: true
			};
			var data = {
				package: newPackage,
				numPackages: self.numPackages
			};
			$uibModalInstance.close(data);
		};

		self.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		self.openContentSelectModal = function () {
			ModalService.showContentSelectModal(self.contentType, undefined, self.contentSelectionHandler);
		};

		self.disableOk = function () {
			return self.selectedContent === defaultContent || !self.packageType.id || self.name === '';
		};

		self.resetDefaultContent = function (isAd) {
			self.selectedContent = defaultContent;
			if (isAd) {
				self.packageType = self.packageTypesMap.shortform;
			}
		};

		self.contentSelectionHandler = function (result) {
			self.selectedContent = result;
		};

		self.onNumPackagesChanged = function (value, min, max) {
			if (value > max) {
				self.numPackages = max;
			} else if (value < min) {
				self.numPackages = min;
			}
		};

		PackageResourceFactory.query({sub: 'categoryTypes'}).$promise.then(function (packageTypes) {
			self.packageTypesMap = {};
			angular.forEach(packageTypes, function (packageType) {
				self.packageTypesMap[packageType.name.toLowerCase().replace(/ /, '')] = packageType;
			});
			self.packageTypes = packageTypes;
		});
	});
